import { PaymentMethodEnum, WalletPaymentMethod } from 'src/Constants/enums'
import { OrderCheckoutBreakdown } from 'src/Redux/artistOrderApi'

type DisplayedPaymentMethodsParams = {
  availablePaymentMethods?: PaymentMethodEnum[]
  walletPaymentMethods: WalletPaymentMethod[]
  isOrderFullyCovered: boolean
  paypalEmail?: string
}

export const getIsOrderFullyCovered = (
  breakdown: OrderCheckoutBreakdown | undefined,
  isEnoughBalance: boolean,
): boolean => (breakdown ? breakdown.totalPayable === 0 : isEnoughBalance)

export const getDisplayedPaymentMethods = ({
  availablePaymentMethods,
  walletPaymentMethods,
  isOrderFullyCovered,
  paypalEmail,
}: DisplayedPaymentMethodsParams): PaymentMethodEnum[] | undefined => {
  if (!availablePaymentMethods) {
    return void 0
  }

  const methods = availablePaymentMethods.filter((method) => {
    switch (method) {
      case PaymentMethodEnum.Credits:
        return isOrderFullyCovered
      case PaymentMethodEnum.STRIPE:
        return true
      case PaymentMethodEnum.PAYPAL:
        return !paypalEmail || !isOrderFullyCovered
      case PaymentMethodEnum.PAYPAL_BILLING_AGREEMENT:
        return Boolean(paypalEmail)
      default:
        return false
    }
  })

  const wallets = isOrderFullyCovered ? [] : walletPaymentMethods

  return [...wallets, ...methods]
}

export const getIsConfirmDisabled = (
  isWalletProcessing: boolean,
  paymentMethod: PaymentMethodEnum,
  displayedPaymentMethods?: PaymentMethodEnum[],
): boolean => {
  if (isWalletProcessing) {
    return true
  }

  if (!displayedPaymentMethods) {
    return false
  }

  return (
    !displayedPaymentMethods.length ||
    !displayedPaymentMethods.includes(paymentMethod)
  )
}
